import { Trans } from '@lingui/macro';
import { clsx } from '@mantine/core';

import { getNameLocal } from '../../../lib/local/get-title';
import { useLocal } from '../../../lib/local/use-local';

import styles from './ticket-tariffs.module.css';

type TicketSeatsProps = {
  tariffs: {
    sum: number;
    items: {
      id: number;
      titles: { nameHy: string; nameEn: string; nameRu: string };
      summ: number;
    }[];
  } | null;
};

export const TicketTariffs = ({ tariffs }: TicketSeatsProps) => {
  const [lang] = useLocal();
  if (!tariffs) return null;

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.colHeaderTitle}>
            <Trans>Вид тарифа</Trans>
          </th>
          <th className={clsx(styles.colHeaderTitle, styles.rightAlign)}>
            <Trans>Стоимость</Trans>
          </th>
        </tr>
      </thead>

      <tbody>
        {tariffs.items.map((tariff) => (
          <tr key={tariff.id} className={styles.row}>
            <td className={styles.cell}>{getNameLocal(lang, tariff.titles)}</td>

            <td
              className={clsx(styles.tariffSum, styles.rightAlign, styles.cell)}
            >
              <span className={styles.price}>{tariff.summ} ֏</span>
            </td>
          </tr>
        ))}
      </tbody>

      <tfoot className={styles.totalContainer}>
        <tr className={styles.totalRow}>
          <th className={styles.totalTitle}>
            <Trans>Итого</Trans>:
          </th>

          <td className={styles.totalValue}>
            <span className={styles.price}>{tariffs.sum} ֏</span>
          </td>
        </tr>
      </tfoot>
    </table>
  );
};
